// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"7d09237d","239":"f786fdbf","453":"f25e1190","455":"fff851af","765":"f552b057","977":"3f852aef"}[chunkId] + ".chunk.js";
};